<template>
  <div
    class="option-card"
    :class="{ 'option-card--selected': selected }"
    role="radio"
    :aria-checked="selected ? 'true' : 'false'"
    tabindex="0"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <div class="option-card__content">
      <span class="option-card__label">{{ label }}</span>
      <span v-if="subtitle" class="option-card__subtitle">{{ subtitle }}</span>
    </div>
    <span class="material-icons-outlined option-card__arrow">
      chevron_right
    </span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label: string;
    subtitle?: string;
    selected?: boolean;
  }>(),
  {
    subtitle: undefined,
    selected: false,
  },
);

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.option-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  margin-bottom: 12px;
  background: #fff;
  border: 1px solid $base-border-color;
  border-radius: $border-radius-medium;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: $primary-color;
  }

  &:focus {
    outline: none;
    border-color: $primary-color;
    box-shadow: 0 0 0 2px rgba($primary-color, 0.2);
  }

  &--selected {
    border-color: $primary-color;
    background-color: $primary-background-color;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  &__label {
    font-size: 1rem;
    font-weight: bold;
    color: $base-font-color;
    line-height: 1.4;
  }

  &__subtitle {
    font-size: 0.875rem;
    color: $tertiary-color;
    line-height: 1.4;
  }

  &__arrow {
    font-size: 1.5rem;
    color: $tertiary-color;
    margin-left: 12px;
    flex-shrink: 0;
  }
}
</style>
